import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";
import { removeEmpty } from "../utils/objectUtils";
import { exportCsv } from "../utils/fileUtils";
import { DateFormatEnum } from "../enums/dateFormatEnum";
import dayjs from "dayjs";
import {returnOnlyNumbersAsInteger} from "../utils/formValidation";
import {saveConfigImages, updatePortalConfigurations} from "./config";
import {string} from "prop-types";
import {lobbyTab} from "../pages/LobbyTab/types";

export async function getAllTags() : Promise<{ tags: string[] }> {
    let res: {tags: string[]} = {
      tags: []
    }
    console.log("pttags.getAllTags")
    await Api.get(endpoints.getConfigsList).then((response) => {
      if(response.status === 200 && response.data) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          const configs = response.data.configs
          //loop through configs and find PT_GAME_TAGS
          let strTags = ""
          configs.forEach((config: { key: string; value: string; }) => {
            if (config.key === "PT_GAME_TAGS"){
              strTags = config.value;
              if (strTags && strTags.length>0)
                res.tags = strTags.split(",")
            }
          })
        }
      }
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
    
    return res
}


export async function addTag(nameParam: string){
  //get tags from server
  let res = await getAllTags()

  //verify tag does not already exist
  let found = false
  let tempArr : string[] = []
  res.tags?.forEach((tag) =>{
    tempArr.push(tag)
    if (tag.toLowerCase() === nameParam.toLowerCase()){
      found = true
    }
  })
  if (!found) {
    //add tag to array
    tempArr.push(nameParam)
    //save tag using config.ts function
    let paramStr = tempArr.join(",")
    let config = {key: "PT_GAME_TAGS", value: paramStr}
    const configArr = [config]
    await updatePortalConfigurations(configArr)

    //reload
    res = await getAllTags()
  } else {
    notificationError(`${nameParam} already exists`)
  }
  return res
}

export async function addTagToDevices(tagParam: string, deviceList: never[]){
  console.log('In addTagToDevices' + JSON.stringify(deviceList))
  let res = {
    tags: []
  }
  let params = {
    tagId: tagParam,
    deviceList: deviceList.map((device: any) => device.id).join()

  }
  let params2 = {
    deviceList: deviceList.map((device: any) => device.id).join()
  }

  console.log(JSON.stringify(params))
  console.log(JSON.stringify(params2))
  /*
  await Api.post(endpoints.addTagToDevices, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  */

  return res
}

export async function removeTagFromDevices(tagParam: string, deviceList: never[]){
  console.log('In removeTagFromDevices' + JSON.stringify(deviceList))
  let res = {
    tags: []
  }
  let params = {
    tagId: tagParam,
    deviceList: deviceList.map((device: any) => device.id).join()
  }
  /*
  await Api.post(endpoints.removeTagFromDevices, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

   */

  return res
}

export async function deleteTag(nameParam: string){
  //get tags from server
  let res = await getAllTags()

  //verify tag exists
  let found = false
  let tempArr : string[] = []
  res.tags?.forEach((tag) =>{
    if (tag.toLowerCase() !== nameParam.toLowerCase()) {
      tempArr.push(tag)
    } else {
      found = true
    }
  })
  if (found) {
    //save tag using config.ts function
    let paramStr = tempArr.join(",")
    let config = {key: "PT_GAME_TAGS", value: paramStr}
    const configArr = [config]
    await updatePortalConfigurations(configArr)

    //reload
    res = await getAllTags()
  } else {
    notificationError(`${nameParam} does not exist`)
  }
  return res
}

export async function getLobbyTabs() : Promise<{ tabs: lobbyTab[] }> {
  let res: {tabs: lobbyTab[]} = {
    tabs: []
  }
  console.log("pttags.getLobbyTabs")
  await Api.get(endpoints.getConfigsList).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        const configs = response.data.configs
        //loop through configs and find PT_GAME_TAGS
        let strTags = ""
        configs.forEach((config: { key: string; value: string; }) => {
          if (config.key === "LOBBY_TABS"){
            res.tabs = JSON.parse(config.value)
          }
        })
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}

export async function saveLobbyTabs(tabs: lobbyTab[]){
  //save tag using config.ts function
  let paramStr = JSON.stringify(tabs)
  let config = {key: "LOBBY_TABS", value: paramStr}
  const configArr = [config]
  await updatePortalConfigurations(configArr)

  //reload
  return await getLobbyTabs()
}

